import styled from "styled-components";

export const StyledCheckboxWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    margin-top: 12px;
`;
